import { render, staticRenderFns } from "./yuyueList.vue?vue&type=template&id=98fa584c&scoped=true&"
import script from "./yuyueList.vue?vue&type=script&lang=js&"
export * from "./yuyueList.vue?vue&type=script&lang=js&"
import style0 from "./yuyueList.vue?vue&type=style&index=0&id=98fa584c&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98fa584c",
  null
  
)

export default component.exports